import React from 'react';

const WithusSections = () => {
  return (
    <div className="bg-gray-50 w-full py-12 md:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-10 md:mb-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight">
            Why You'll Love Working <br />
            <span className="text-[#1C74BB]">With Us</span>
          </h1>

          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            We understand that a great workplace is not just about the work you do, but also about how you feel doing it.
            Here's what makes Dynamic Softlink an exciting place to grow your career
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {/* Box 1 */}
          <div className="group bg-white rounded-xl shadow-lg p-6 flex flex-col sm:flex-row items-start 
            transition-all duration-300  hover:shadow-xl hover:scale-[1.02]">
            <div className="bg-blue-100 p-4 rounded-lg mb-4 sm:mb-0 sm:mr-6 flex-shrink-0">
              <svg className="w-8 h-8 text-[#1C74BB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 group-hover:text-[#1C74BB] transition-colors duration-300">
                Challenging & Impactful Projects
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                Work on high-value projects across industries where your contributions truly matter and create real impact
              </p>
            </div>
          </div>

          {/* Box 2 */}
          <div className="group bg-white rounded-xl shadow-lg p-6 flex flex-col sm:flex-row items-start 
            transition-all duration-300  hover:shadow-xl hover:scale-[1.02]">
            <div className="bg-green-100 p-4 rounded-lg mb-4 sm:mb-0 sm:mr-6 flex-shrink-0">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 group-hover:text-[#1C74BB] transition-colors duration-300">
                Supportive & Flexible Culture
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                We respect work-life balance and encourage creativity, collaboration, and innovation in everything we do
              </p>
            </div>
          </div>

          {/* Box 3 */}
          <div className="group bg-white rounded-xl shadow-lg p-6 flex flex-col sm:flex-row items-start 
            transition-all duration-300  hover:shadow-xl hover:scale-[1.02]">
            <div className="bg-purple-100 p-4 rounded-lg mb-4 sm:mb-0 sm:mr-6 flex-shrink-0">
              <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
              </svg>
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 group-hover:text-[#1C74BB] transition-colors duration-300">
                Cutting-Edge Technologies
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                Stay ahead of the curve with opportunities to learn and apply the latest in IT, AI, and UX technologies
              </p>
            </div>
          </div>

          {/* Box 4 */}
          <div className="group bg-white rounded-xl shadow-lg p-6 flex flex-col sm:flex-row items-start 
            transition-all duration-300 hover:shadow-xl hover:scale-[1.02]">
            <div className="bg-yellow-100 p-4 rounded-lg mb-4 sm:mb-0 sm:mr-6 flex-shrink-0">
              <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 group-hover:text-[#1C74BB] transition-colors duration-300">
                Growth & Rewards
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                Enjoy competitive pay, performance perks, and career advancement opportunities that recognize your talent
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithusSections;
